<template>
  <div class="media-icons">
    <div v-if="stock && stock.have_720 !== '0'">
      <img src="/ics/property/img/details/720_blk.svg" />
    </div>
    <div v-if="stock && stock.have_virtualtour !== '0'">
      <img src="/ics/property/img/details/vr-01-blk.svg" />
    </div>
    <div v-if="stock && stock.have_video !== '0'">
      <img src="/ics/property/img/details/video-01-blk.svg" />
    </div>
  </div>
</template>

<script>
export default {
  props: ['stock'],
  // can add props like have_360photo, have_virtualtour, have_video later
};
</script>

<style scoped>
.media-icons {
  display: flex;
  gap: 3px;
}

.media-icons div {
  margin-left: 5px;
  height: 20px;
  display: flex;
}

.media-icons div img {
  height: 100%;
}
</style>